module.exports = __webpack_public_path__ + "img/9788958076537.f32658a7.jpg";